module.exports = __webpack_public_path__ + "img/Unit_Guide_alcopop.cb00a64e.svg";